import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';
import { ManagerAuthGuardWrap } from '@/router/auth/AuthGuardWrap';

export const 원클릭_판매확장_부모_라우터 = {
  index: {
    path: '/settings/sale-platform-extension',
    async lazy() {
      const { default: Page } = await import('@/router/settings/sale-platform-extension/원클릭_판매확장_설정/index');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원클릭 판매확장 설정',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

export const 원클릭_판매확장_라우터 = {
  sync: {
    path: '/settings/sale-platform-extension/sync',
    async lazy() {
      const { default: Page } = await import(
        '@/router/settings/sale-platform-extension/원클릭_판매확장_설정/원클릭_판매_플랫폼_확장_설정_페이지'
      );
      return {
        Component: Page,
      };
    },
    handle: {
      title: '원클릭 판매 플랫폼 확장',
    },
  } satisfies LookoRouteObject,
};

export const 기본필수설정_라우터 = {
  카페24: {
    path: '/settings/sale-platform-extension/sync/cafe24/requirement-setting',
    async lazy() {
      const { default: Page } = await import(
        '@/router/settings/sale-platform-extension/원클릭_판매확장_설정/카페24_기본필수설정_페이지'
      );
      return {
        Component: ManagerAuthGuardWrap(Page),
      };
    },
    handle: {
      title: '기본 필수 설정 (카페24)',
    },
  } satisfies LookoRouteObject,
  네이버: {
    path: '/settings/sale-platform-extension/sync/naver/requirement-setting',
    async lazy() {
      const { default: Page } = await import(
        '@/router/settings/sale-platform-extension/원클릭_판매확장_설정/네이버_기본필수설정_페이지'
      );
      return {
        Component: ManagerAuthGuardWrap(Page),
      };
    },
    handle: {
      title: '기본 필수 설정 (네이버)',
    },
  } satisfies LookoRouteObject,
  번개장터: {
    path: '/settings/sale-platform-extension/sync/bunjang/requirement-setting',
    async lazy() {
      const { default: Page } = await import(
        '@/router/settings/sale-platform-extension/원클릭_판매확장_설정/번개장터_기본필수설정_페이지'
      );
      return {
        Component: ManagerAuthGuardWrap(Page),
      };
    },
    handle: {
      title: '기본 필수 설정 (번개장터)',
    },
  } satisfies LookoRouteObject,
};

const 원클릭_판매확장_설정_라우터: LookoRouteObject[] = [
  ...values(원클릭_판매확장_부모_라우터),
  ...values(원클릭_판매확장_라우터),
  ...values(기본필수설정_라우터),
];

export default 원클릭_판매확장_설정_라우터;
